<template>
  <div :class="video_popup_class" @click="close_popup">
    <div class="option-bar" v-if="sub_popup == null">
      <span class="close-link" @click="try_to_close_popup">X</span>
    </div>
    <div
      class="popup_content_container w-full mx-auto text-left relative"
      @click="prevent_close($event)"
    >
      <div v-if="sub_popup == null">
        <!--        <h1 class="text-main-color uppercase font-bold mb-8 text-center">-->
        <!--          {{ getCurrentSectionContent().title }}-->
        <!--        </h1>-->

        <ul :class="pdf_list_class">
          <li
            class="text-center"
            v-for="(item, index) in getCurrentSectionContent().list"
            :key="'pdf_list_item_' + index"
          >
            <!-- internal links, should open a sub content in the popup -->
            <a
              class="block"
              target="_blank"
              href="#"
              @click.prevent="show_internal_content(index)"
              v-if="
                'undefined' != typeof item.type &&
                item.type.indexOf('internal') >= 0
              "
              ><img
                v-if="'undefined' != typeof item.thumb"
                :src="
                  'static/content/' +
                  selected_section +
                  '/' +
                  selected_sub_section +
                  '/thumb/' +
                  item.thumb
                "
            /></a>
            <!-- for external links -->
            <a
              class="block"
              target="_blank"
              :href="get_item_href(item)"
              v-ga="
                $ga.commands.trackExternalLink.bind(
                  get_this,
                  get_item_href(item)
                )
              "
              @click="show_external_content(index)"
              v-else
              ><img
                v-if="'undefined' != typeof item.thumb"
                :src="
                  'static/content/' +
                  selected_section +
                  '/' +
                  selected_sub_section +
                  '/thumb/' +
                  item.thumb
                "
            /></a>
          </li>
        </ul>
        <!--ISI CONTENT-->
        <div
          class="bg-white my-2 rounded scrolling-auto isi-container"
          v-if="selected_sub_section != '8-Refresh'"
        >
          <div v-if="selected_sub_section == '1-Alphagan'">
            <p><b>INDICATION AND USAGE</b></p>
            <p>
              ALPHAGAN<sup>®</sup> P (brimonidine tartrate ophthalmic solution)
              0.1% or 0.15% is an alpha-adrenergic receptor agonist indicated
              for the reduction of elevated intraocular pressure (IOP) in
              patients with open-angle glaucoma or ocular hypertension.
            </p>
            <p><b>IMPORTANT SAFETY INFORMATION</b></p>
            <p><b>CONTRAINDICATIONS</b></p>
            <p>
              <b>Neonates and Infants (under the age of 2 years):</b>
              ALPHAGAN<sup>®</sup>
              P is contraindicated in neonates and infants (under the age of 2
              years).
            </p>
            <p>
              <b>Hypersensitivity Reactions:</b> ALPHAGAN<sup>®</sup> P is
              contraindicated in patients who have exhibited a hypersensitivity
              reaction to any component of this medication in the past.
            </p>
            <p><b>WARNINGS AND PRECAUTIONS</b></p>
            <p>
              <b>Potentiation of Vascular Insufficiency:</b> ALPHAGAN<sup
                >®</sup
              >
              P may potentiate syndromes associated with vascular insufficiency.
              ALPHAGAN<sup>®</sup> P should be used with caution in patients
              with depression, cerebral or coronary insufficiency, Raynaud's
              phenomenon, orthostatic hypotension, or thromboangiitis
              obliterans.
            </p>
            <p>
              <b>Severe Cardiovascular Disease:</b> Although brimonidine
              tartrate ophthalmic solution had minimal effect on the blood
              pressure of patients in clinical studies, caution should be
              exercised in treating patients with severe cardiovascular disease.
            </p>
            <p>
              <b>Contamination of Topical Ophthalmic Products After Use:</b>
              There have been reports of bacterial keratitis associated with the
              use of multiple-dose containers of topical ophthalmic products.
              These containers had been inadvertently contaminated by patients
              who, in most cases, had a concurrent corneal disease or a
              disruption of the ocular epithelial surface.
            </p>
            <p><b>DRUG INTERACTIONS</b></p>
            <p>
              <b>Antihypertensives/Cardiac Glycosides:</b> Because ALPHAGAN<sup
                >®</sup
              >
              P may reduce blood pressure, caution in using drugs such as
              antihypertensives and/or cardiac glycosides with ALPHAGAN<sup
                >®</sup
              >
              P is advised.
            </p>
            <p>
              <b>CNS Depressants:</b> Although specific drug interaction studies
              have not been conducted with ALPHAGAN<sup>®</sup> P, the
              possibility of an additive or potentiating effect with CNS
              depressants (alcohol, barbiturates, opiates, sedatives, or
              anesthetics) should be considered.
            </p>
            <p>
              <b>Tricyclic Antidepressants:</b> Tricyclic antidepressants have
              been reported to blunt the hypotensive effect of systemic
              clonidine. It is not known whether the concurrent use of these
              agents with ALPHAGAN<sup>®</sup> P in humans can lead to resulting
              interference with the IOP-lowering effect. Caution is advised in
              patients taking tricyclic antidepressants, which can affect the
              metabolism and uptake of circulating amines.
            </p>
            <p>
              <b>Monoamine Oxidase Inhibitors:</b> Monoamine oxidase (MAO)
              inhibitors may theoretically interfere with the metabolism of
              brimonidine and potentially result in an increased systemic side
              effect such as hypotension. Caution is advised in patients taking
              MAO inhibitors, which can affect the metabolism and uptake of
              circulating amines.
            </p>
            <p><b>ADVERSE REACTIONS</b></p>
            <p>
              Adverse reactions occurring in approximately 10% to 20% of the
              subjects receiving brimonidine ophthalmic solution (0.1% to 0.2%)
              included: allergic conjunctivitis, conjunctival hyperemia, and eye
              pruritus. Adverse reactions occurring in approximately 5% to 9%
              included: burning sensation, conjunctival folliculosis,
              hypertension, ocular allergic reaction, oral dryness, and visual
              disturbance.
            </p>
            <p>
              <a
                href="https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/alphaganp_pi.pdf"
                target="_blank"
                v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/alphaganp_pi.pdf'
                  )
                "
              >
                <u>
                  Please click here for full ALPHAGAN<sup>®</sup> P 0.1%
                  Prescribing Information.
                </u>
              </a>
            </p>
          </div>
          <div v-if="selected_sub_section == '2-Lumigan'">
            <p><b>INDICATION</b></p>
            <p>
              LUMIGAN<sup>®</sup> (bimatoprost ophthalmic solution) 0.01% is
              indicated for the reduction of elevated intraocular pressure in
              patients with open angle glaucoma or ocular hypertension.
            </p>
            <p><b>IMPORTANT SAFETY INFORMATION</b></p>
            <p><b>CONTRAINDICATIONS</b></p>
            <p>
              LUMIGAN<sup>®</sup> 0.01% is contraindicated in patients with
              hypersensitivity to bimatoprost or to any of the ingredients.
            </p>
            <p><b>WARNINGS AND PRECAUTIONS</b></p>
            <p><b>Pigmentation</b></p>
            <p>
              Bimatoprost ophthalmic solution has been reported to cause changes
              to pigmented tissues. The most frequently reported changes have
              been increased pigmentation of the iris, periorbital tissue
              (eyelid) and eyelashes. Pigmentation is expected to increase as
              long as bimatoprost is administered. After discontinuation of
              bimatoprost, pigmentation of the iris is likely to be permanent,
              while pigmentation of the periorbital tissue and eyelash changes
              have been reported to be reversible in some patients. Patients who
              receive treatment should be informed of the possibility of
              increased pigmentation. The long term effects of increased
              pigmentation are not known. Iris color change may not be
              noticeable for several months to years. While treatment with
              LUMIGAN<sup>®</sup> 0.01% can be continued in patients who develop
              noticeably increased iris pigmentation, these patients should be
              examined regularly.
            </p>
            <p><b>Eyelash Changes</b></p>
            <p>
              LUMIGAN<sup>®</sup> 0.01% may gradually change eyelashes and
              vellus hair in the treated eye. These changes include increased
              length, thickness, and number of lashes. Eyelash changes are
              usually reversible upon discontinuation of treatment.
            </p>
            <p><b>Intraocular Inflammation</b></p>
            <p>
              Prostaglandin analogs, including bimatoprost, have been reported
              to cause intraocular inflammation. In addition, because these
              products may exacerbate inflammation, caution should be used in
              patients with active intraocular inflammation (e.g., uveitis).
            </p>
            <p><b>Macular Edema</b></p>
            <p>
              Macular edema, including cystoid macular edema, has been reported
              during treatment with bimatoprost ophthalmic solution. LUMIGAN<sup
                >®</sup
              >
              0.01% should be used with caution in aphakic patients, in
              pseudophakic patients with a torn posterior lens capsule, or in
              patients with known risk factors for macular edema.
            </p>
            <p><b>Use with Contact Lenses</b></p>
            <p>
              LUMIGAN<sup>®</sup> 0.01% contains benzalkonium chloride, which
              may be absorbed by and cause discoloration of soft contact lenses.
              Contact lenses should be removed prior to instillation of
              LUMIGAN<sup>®</sup>
              0.01% and may be reinserted 15 minutes following its
              administration.
            </p>
            <p><b>ADVERSE REACTIONS</b></p>
            <p>
              In a 12-month clinical study with bimatoprost ophthalmic solutions
              0.01%, the most common adverse reaction was conjunctival hyperemia
              (31%). Approximately 1.6% of patients discontinued therapy due to
              conjunctival hyperemia. Other adverse drug reactions (reported in
              1 to 4% of patients) with LUMIGAN<sup>®</sup> 0.01% in this study
              included conjunctival edema, conjunctival hemorrhage, eye
              irritation, eye pain, eye pruritus, erythema of eyelid, eyelids
              pruritus, growth of eyelashes, hypertrichosis, instillation site
              irritation, punctate keratitis, skin hyperpigmentation, vision
              blurred, and visual acuity reduced.
            </p>
            <p><b>USE IN SPECIFIC POPULATIONS</b></p>
            <p><b>Pediatric Use</b></p>
            <p>
              Use in pediatric patients below the age of 16 years is not
              recommended because of potential safety concerns related to
              increased pigmentation following long-term chronic use.
            </p>
            <p>
              <a
                href="https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/20170729-LUMIGAN-0-01%25-USPI-71807US15.pdf"
                target="_blank"
                v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/20170729-LUMIGAN-0-01%25-USPI-71807US15.pdf'
                  )
                "
              >
                <u>
                  Click here for full LUMIGAN<sup>®</sup> 0.01% Prescribing
                  Information.
                </u>
              </a>
            </p>
          </div>
          <div v-if="selected_sub_section == '3-Durysta'">
            <p><b>Indications and Usage</b></p>
            <p>
                DURYSTA™ (bimatoprost intracameral implant) is indicated for the reduction of intraocular pressure (IOP) in patients with open angle glaucoma (OAG) or ocular hypertension (OHT).
            </p>
            <p><b>Important Safety Information</b></p>
            <p><b>Contraindications</b></p>
            <p>
                DURYSTA™ is contraindicated in patients with: active or suspected ocular or periocular infections; corneal endothelial cell dystrophy (e.g., Fuchs’ Dystrophy); prior corneal transplantation or endothelial cell transplants (e.g., Descemet’s Stripping Automated Endothelial Keratoplasty [DSAEK]); absent or ruptured posterior lens capsule, due to the risk of implant migration into the posterior segment; hypersensitivity to bimatoprost or to any other components of the product.
            </p>

            <p><b>Warnings and Precautions</b></p>
            <p>
                The presence of DURYSTA™ implants has been associated with corneal adverse reactions and increased risk of corneal endothelial cell loss. Administration of DURYSTA™ should be limited to a single implant per eye without retreatment. Caution should be used when prescribing DURYSTA™ in patients with limited corneal endothelial cell reserve.
            </p>
            <p>
                DURYSTA™ should be used with caution in patients with narrow iridocorneal angles (Shaffer grade ˂ 3) or anatomical obstruction (e.g., scarring) that may prohibit settling in the inferior angle.
            </p>
            <p>
                Macular edema, including cystoid macular edema, has been reported during treatment with ophthalmic bimatoprost, including DURYSTA™ intracameral implant. DURYSTA™ should be used with caution in aphakic patients, in pseudophakic patients with a torn posterior lens capsule, or in patients with known risk factors for macular edema.
            </p>
            <p>
                Prostaglandin analogs, including DURYSTA™, have been reported to cause intraocular inflammation. DURYSTA™ should be used with caution in patients with active intraocular inflammation (e.g., uveitis) because the inflammation may be exacerbated.
            </p>
            <p>
                Ophthalmic bimatoprost, including DURYSTA™ intracameral implant, has been reported to cause changes to pigmented tissues, such as increased pigmentation of the iris. Pigmentation of the iris is likely to be permanent. Patients who receive treatment should be informed of the possibility of increased pigmentation. While treatment with DURYSTA™ can be continued in patients who develop noticeably increased iris pigmentation, these patients should be examined regularly.
            </p>
            <p>
                Intraocular surgical procedures and injections have been associated with endophthalmitis. Proper aseptic technique must always be used with administering DURYSTA™, and patients should be monitored following the administration.
            </p>

            <p><b>Adverse Reactions</b></p>
            <p>
                In controlled studies, the most common ocular adverse reaction reported by 27% of patients was conjunctival hyperemia. Other common adverse reactions reported in 5%10% of patients were foreign body sensation, eye pain, photophobia, conjunctival hemorrhage, dry eye, eye irritation, intraocular pressure increased, corneal endothelial cell loss, vision blurred, iritis, and headache.
            </p>

            <p>
                <b>Please see full Prescribing Information available at </b>
                <a href="https://media.allergan.com/products/durysta_pi.pdf"
                   target="_blank"
                   v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://media.allergan.com/products/durysta_pi.pdf'
                  )
                ">
                    <u>https://media.allergan.com/products/durysta_pi.pdf</u>
                </a> or
                <a href="https://www.durystahcp.com/"
                   target="_blank"
                   v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://www.durystahcp.com/'
                  )
                ">
                    <u>DurystaHCP.com</u>
                </a>
            </p>
          </div>
          <div v-if="selected_sub_section == '4-Restasis'">
            <p><b>INDICATIONS AND USAGE</b></p>
            <p>
              RESTASIS<sup>®</sup> (Cyclosporine Ophthalmic Emulsion) 0.05% and
              RESTASIS MULTIDOSE<sup>TM</sup> (Cyclosporine Ophthalmic Emulsion)
              0.05% ophthalmic emulsion are indicated to increase tear
              production in patients whose tear production is presumed to be
              suppressed due to ocular inflammation associated with
              keratoconjunctivitis sicca. Increased tear production was not seen
              in patients currently taking topical anti-inflammatory drugs or
              using punctal plugs.
            </p>

            <p><b>IMPORTANT SAFETY INFORMATION</b></p>
            <p><b>Contraindications</b></p>
            <p>
              RESTASIS<sup>®</sup> and RESTASIS MULTIDOSE<sup>TM</sup> are
              contraindicated in patients with known or suspected
              hypersensitivity to any of the ingredients in the formulation.
            </p>

            <p><b>WARNINGS AND PRECAUTIONS</b></p>
            <p>
              <b>Potential for Eye Injury and Contamination:</b> Be careful not
              to touch the container tip to your eye or other surfaces to avoid
              potential for eye injury and contamination.
            </p>
            <p>
              <b>Use With Contact Lenses:</b> RESTASIS<sup>®</sup> and RESTASIS
              MULTIDOSE<sup>TM</sup> should not be administered while wearing
              contact lenses. If contact lenses are worn, they should be removed
              prior to the administration of the emulsion. Lenses may be
              reinserted 15 minutes following administration of RESTASIS<sup
                >®</sup
              >
              and RESTASIS MULTIDOSE<sup>TM</sup> ophthalmic emulsion.
            </p>
            <p><b>ADVERSE REACTIONS</b></p>
            <p>
              In clinical trials, the most common adverse reaction following the
              use of cyclosporine ophthalmic emulsion 0.05% was ocular burning
              (upon instillation)—17%. Other reactions reported in 1% to 5% of
              patients included conjunctival hyperemia, discharge, epiphora, eye
              pain, foreign body sensation, pruritus, stinging, and visual
              disturbance (most often blurring).
            </p>

            <p>
              <a
                href="https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/RESTASIS_pi.pdf"
                target="_blank"
                v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/RESTASIS_pi.pdf'
                  )
                "
              >
                <u>
                  Please click here to view full Prescribing Information for
                  RESTASIS<sup>®</sup>.
                </u>
              </a>
            </p>
            <p>
              <a
                href="https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/Restasis-MultiDose_pi.pdf"
                target="_blank"
                v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/Restasis-MultiDose_pi.pdf'
                  )
                "
              >
                <u>
                  Please click here to view full Prescribing Information for
                  RESTASIS MULTIDOSE<sup>TM</sup>.
                </u>
              </a>
            </p>
          </div>
          <div v-if="selected_sub_section == '5-Combigan'">
            <p>
              <b>INDICATIONS AND USAGE:</b> COMBIGAN<sup>®</sup> (brimonidine
              tartrate/timolol maleate ophthalmic solution) 0.2%/0.5% is an
              alpha‐adrenergic receptor agonist with a beta‐adrenergic receptor
              inhibitor indicated for the reduction of elevated intraocular
              pressure (IOP) in patients with glaucoma or ocular hypertension
              who require adjunctive or replacement therapy due to inadequately
              controlled IOP; the IOP‐lowering of COMBIGAN<sup>®</sup> dosed
              twice a day was slightly less than that seen with the concomitant
              administration of 0.5% timolol maleate ophthalmic solution dosed
              twice a day and 0.2% brimonidine tartrate ophthalmic solution
              dosed three times per day.
            </p>

            <p><b>IMPORTANT SAFETY INFORMATION</b></p>
            <p>
              <b>CONTRAINDICATIONS:</b> COMBIGAN<sup>®</sup> is contraindicated
              in patients with reactive airway disease including bronchial
              asthma; a history of bronchial asthma; severe chronic obstructive
              pulmonary disease; in patients with sinus bradycardia; second or
              third degree atrioventricular block; overt cardiac failure;
              cardiogenic shock; in neonates and infants (aged 2 years and
              younger); in patients with a hypersensitivity reaction to any
              component of COMBIGAN<sup>®</sup> in the past.
            </p>

            <p>
              <b>WARNINGS AND PRECAUTIONS:</b> COMBIGAN<sup>®</sup> contains
              timolol maleate. COMBIGAN<sup>®</sup> is administered topically,
              but can be absorbed systemically. The adverse reactions with
              systemic administration of beta‐adrenergic blocking agents may
              occur with topical use (eg, severe respiratory reactions and
              cardiac reactions, including death due to bronchospasm in patients
              with asthma, and rarely death in association with cardiac failure,
              have been reported with systemic or ophthalmic administration of
              timolol maleate). Ophthalmic beta‐blockers may impair compensatory
              tachycardia and increase risk of hypotension.
            </p>
            <p></p>
            <p>
              Sympathetic stimulation may be essential to support the
              circulation in patients with diminished myocardial contractility,
              and its inhibition by beta‐adrenergic receptor blockade may
              precipitate more severe failure. In patients with no history of
              cardiac failure, continued depression of the myocardium with
              beta‐blocking agents over time can lead to cardiac failure.
              Discontinue COMBIGAN<sup>®</sup> at the first sign or symptom of
              cardiac failure. Patients with chronic obstructive pulmonary
              disease (eg, chronic bronchitis, emphysema) of mild or moderate
              severity, bronchospastic disease, or a history of bronchospastic
              disease should not receive beta‐blocking agents, including
              COMBIGAN<sup>®</sup>.
            </p>
            <p>
              COMBIGAN<sup>®</sup> may potentiate syndromes associated with
              vascular insufficiency. Use caution in patients with depression,
              cerebral or coronary insufficiency, Raynaud’s phenomenon,
              orthostatic hypotension, or thromboangiitis obliterans.
            </p>
            <p>
              Patients taking beta‐blockers with a history of atopy or severe
              anaphylactic reactions to a variety of allergens may be more
              reactive to repeated accidental, diagnostic, or therapeutic
              challenge with such allergens. Such patients may be unresponsive
              to the usual doses of epinephrine used to treat anaphylactic
              reactions.
            </p>
            <p>
              Beta‐adrenergic blockade can potentiate muscle weakness with
              myasthenic symptoms (eg, diplopia, ptosis, and generalized
              weakness). Although rare, timolol can increase muscle weakness in
              some patients with myasthenia gravis or myasthenic symptoms.
            </p>
            <p>
              Beta‐adrenergic receptor blocking agents may mask the signs and
              symptoms of acute hypoglycemia and clinical signs (eg,
              tachycardia) of hyperthyroidism. Use caution in patients subject
              to spontaneous hypoglycemia or in diabetic patients (especially
              those with labile diabetes) who are receiving insulin or oral
              hypoglycemic agents. Carefully manage patients who may develop
              thyrotoxicosis to avoid abrupt withdrawal of beta‐adrenergic
              blocking agents that might precipitate a thyroid storm.
            </p>
            <p>
              Ocular hypersensitivity has occurred with brimonidine tartrate
              ophthalmic solutions 0.2% (eg, increase in IOP).
            </p>
            <p>
              Some authorities recommend gradual withdrawal of beta‐adrenergic
              receptor blocking agents due to impairment of beta‐adrenergically
              mediated reflexes during surgery. If necessary during surgery, the
              effects of beta‐adrenergic blocking agents may be reversed by
              sufficient doses of adrenergic agonists.
            </p>

            <p>
              <b>ADVERSE REACTIONS:</b> The most frequent reactions with
              COMBIGAN<sup>®</sup> in about 5% to 15% of patients included:
              allergic conjunctivitis, conjunctival folliculosis, conjunctival
              hyperemia, eye pruritus, ocular burning, and stinging.
            </p>

            <p>
              <b>DRUG INTERACTIONS:</b> COMBIGAN<sup>®</sup> may reduce blood
              pressure. Use caution in patients on antihypertensives and/or
              cardiac glycosides.
            </p>
            <p>
              Observe patients receiving a beta‐adrenergic blocking agent either
              orally or intravenously and COMBIGAN<sup>®</sup> for additive
              effects of beta‐blockade, both systemic and on intraocular
              pressure. Concomitant use of two topical beta‐ adrenergic blocking
              agents is not recommended.
            </p>
            <p>
              Use caution in the co‐administration of beta‐adrenergic blocking
              agents (eg, COMBIGAN<sup>®</sup>) and oral or intravenous calcium
              antagonists due to possible atrioventricular conduction
              disturbances, left ventricular failure, and hypotension. Avoid
              co‐administration in patients with impaired cardiac function.
            </p>
            <p>
              Observe patients closely when a beta‐blocker is administered to
              patients receiving catecholamine‐depleting drugs (eg, reserpine)
              due to possible additive effects and the production of hypotension
              and/or marked bradycardia, which may result in vertigo, syncope,
              or postural hypotension.
            </p>
            <p>
              Specific drug interaction studies have not been conducted with
              COMBIGAN<sup>®</sup>, but consider the possibility of an additive
              or potentiating effect with CNS depressants (alcohol,
              barbiturates, opiates, sedatives, or anesthetics). Concomitant use
              of beta‐adrenergic blocking agents with digitalis and calcium
              antagonists may have additive effects in prolonging
              atrioventricular conduction time.
            </p>
            <p>
              Potentiated systemic beta‐blockade (eg, decreased heart rate,
              depression) has been reported with combined use of CYP2D6
              inhibitors (eg, quinidine, SSRIs) and timolol.
            </p>
            <p>
              Tricyclic antidepressants (TCAs) can blunt the hypotensive effect
              of systemic clonidine. It is not known whether the concurrent use
              of TCAs with COMBIGAN<sup>®</sup> in humans can interfere with the
              IOP‐lowering effect. Caution is advised in patients taking TCAs,
              which can affect the metabolism and uptake of circulating amines.
            </p>
            <p>
              Monoamine oxidase (MAO) inhibitors may theoretically interfere
              with the metabolism of brimonidine and potentially increase
              systemic side effects such as hypotension. Use caution in patients
              taking MAO inhibitors, which can affect the metabolism and uptake
              of circulating amines.
            </p>

            <p>
              <a
                href="https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/20151015-Combigan-USPI-72060US15.pdf"
                target="_blank"
                v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/20151015-Combigan-USPI-72060US15.pdf'
                  )
                "
              >
                <u>
                  Please click here for full Prescribing Information for
                  COMBIGAN<sup>®</sup>.
                </u>
              </a>
            </p>
          </div>
          <div v-if="selected_sub_section == '6-Xen'">
            <p><b>INDICATIONS</b></p>
            <p>
              The XEN<sup>®</sup> Glaucoma Treatment System (XEN<sup>®</sup> 45
              Gel Stent preloaded into a XEN<sup>®</sup> Injector) is indicated
              for the management of refractory glaucomas, including cases where
              previous surgical treatment has failed, cases of primary
              open-angle glaucoma, and pseudoexfoliative or pigmentary glaucoma
              with open angles that are unresponsive to maximum tolerated
              medical therapy.
            </p>

            <p><b>IMPORTANT SAFETY INFORMATION</b></p>
            <p><b>CONTRAINDICATIONS</b></p>
            <p>
              XEN<sup>®</sup> Gel Stent is contraindicated in angle-closure
              glaucoma where angle has not been surgically opened, previous
              glaucoma shunt/valve or conjunctival scarring/pathologies in the
              target quadrant, active inflammation, active iris
              neovascularization, anterior chamber intraocular lens, intraocular
              silicone oil, and vitreous in the anterior chamber.
            </p>

            <p><b>WARNINGS</b></p>
            <p>
              XEN<sup>®</sup> Gel Stent complications may include choroidal
              effusion, hyphema, hypotony, implant migration, implant exposure,
              wound leak, need for secondary surgical intervention, and
              intraocular surgery complications. Safety and effectiveness in
              neovascular, congenital, and infantile glaucoma has not been
              established. Avoid digital pressure following implantation of the
              XEN<sup>®</sup> Gel Stent to avoid the potential for implant
              damage.
            </p>

            <p><b>PRECAUTIONS</b></p>
            <p>
              Examine the XEN<sup>®</sup> Gel Stent and XEN<sup>®</sup> Injector
              in the operating room prior to use. Monitor intraocular pressure
              (IOP) postoperatively and if not adequately maintained, manage
              appropriately. Stop the procedure immediately if increased
              resistance is observed during implantation and use a new XEN<sup
                >®</sup
              >
              system. Safety and effectiveness of more than a single implanted
              XEN<sup>®</sup> Gel Stent has not been studied.
            </p>

            <p><b>ADVERSE EVENTS</b></p>
            <p>
              The most common postoperative adverse events included
              best-corrected visual acuity loss of ≥ 2 lines (≤ 30 days 15.4%; >
              30 days 10.8%; 12 months 6.2%), hypotony IOP < 6 mm Hg at any time
              (24.6%; no clinically significant consequences were associated, no
              cases of persistent hypotony, and no surgical intervention was
              required), IOP increase ≥ 10 mm Hg from baseline (21.5%), and
              needling procedure (32.3%).
            </p>

            <p>
              Caution: Federal law restricts this device to sale by or on the
              order of a licensed physician.
              <a
                href="https://allergan-web-cdn-prod.azureedge.net/actavis/actavis/media/allergan-pdf-documents/labeling/xen/dfu_xen_glaucoma_treatment_system_us_feb2017.pdf"
                target="_blank"
                v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://allergan-web-cdn-prod.azureedge.net/actavis/actavis/media/allergan-pdf-documents/labeling/xen/dfu_xen_glaucoma_treatment_system_us_feb2017.pdf'
                  )
                "
                ><u>Please click here for the full Directions for Use.</u></a
              >
              Please call 1-800-433-8871 to report an adverse event.
            </p>
          </div>
          <div v-if="selected_sub_section == '7-Ozurdex'">
            <p>
              <b>OZURDEX<sup>®</sup> (dexamethasone intravitreal implant)</b>
            </p>
            <p>
              Please find Indications and Usage following important safety
              information.
            </p>

            <p><b>IMPORTANT SAFETY INFORMATION</b></p>
            <p><b>Contraindications</b></p>
            <p>
              <b>Ocular or Periocular Infections:</b> OZURDEX<sup>®</sup>
              (dexamethasone intravitreal implant) is contraindicated in
              patients with active or suspected ocular or periocular infections
              including most viral diseases of the cornea and conjunctiva,
              including active epithelial herpes simplex keratitis (dendritic
              keratitis), vaccinia, varicella, mycobacterial infections, and
              fungal diseases.
            </p>

            <p>
              <b>Glaucoma:</b> OZURDEX<sup>®</sup> is contraindicated in
              patients with glaucoma, who have cup to disc ratios of greater
              than 0.8.
            </p>

            <p>
              <b>Torn or Ruptured Posterior Lens Capsule:</b> OZURDEX<sup
                >®</sup
              >
              is contraindicated in patients whose posterior lens capsule is
              torn or ruptured because of the risk of migration into the
              anterior chamber. Laser posterior capsulotomy in pseudophakic
              patients is not a contraindication for OZURDEX<sup>®</sup> use.
            </p>

            <p>
              <b>Hypersensitivity:</b> OZURDEX<sup>®</sup> is contraindicated in
              patients with known hypersensitivity to any components of this
              product.
            </p>

            <p><b>Warnings and Precautions</b></p>
            <p>
              <b>Intravitreal Injection‐related Effects:</b> Intravitreal
              injections, including those with OZURDEX<sup>®</sup>, have been
              associated with endophthalmitis, eye inflammation, increased
              intraocular pressure, and retinal detachments. Patients should be
              monitored regularly following the injection.
            </p>

            <p>
              <b>Steroid‐related Effects:</b> Use of corticosteroids including
              OZURDEX<sup>®</sup> may produce posterior subcapsular cataracts,
              increased intraocular pressure, glaucoma, and may enhance the
              establishment of secondary ocular infections due to bacteria,
              fungi, or viruses. Corticosteroids are not recommended to be used
              in patients with a history of ocular herpes simplex because of the
              potential for reactivation of the viral infection.
            </p>

            <p><b>Adverse Reactions</b></p>
            <p><b>Diabetic Macular Edema</b></p>
            <p>
              Ocular adverse reactions reported by greater than or equal to 1%
              of patients in the two combined 3-year clinical trials following
              injection of OZURDEX<sup>®</sup> for diabetic macular edema
              include: cataract (68%), conjunctival hemorrhage (23%), visual
              acuity reduced (9%), conjunctivitis (6%), vitreous floaters (5%),
              conjunctival edema (5%), dry eye (5%), vitreous detachment (4%),
              vitreous opacities (3%), retinal aneurysm (3%), foreign body
              sensation (2%), corneal erosion (2%), keratitis (2%), anterior
              chamber inflammation (2%), retinal tear (2%), eyelid ptosis (2%).
              Non-ocular adverse reactions reported by greater than or equal to
              5% of patients include: hypertension (13%) and bronchitis (5%).
            </p>

            <p>
              <b>Increased Intraocular Pressure:</b> IOP elevation greater than
              or equal to 10 mm Hg from baseline at any visit was seen in 28% of
              OZURDEX<sup>®</sup> patients versus 4% of sham patients. 42% of
              the patients who received OZURDEX<sup>®</sup> were subsequently
              treated with IOP-lowering medications during the study versus 10%
              of sham patients.
            </p>
            <p>
              The increase in mean IOP was seen with each treatment cycle, and
              the mean IOP generally returned to baseline between treatment
              cycles (at the end of the 6-month period).
            </p>

            <p>
              <b>Cataracts and Cataract Surgery:</b> The incidence of cataract
              development in patients who had a phakic study eye was higher in
              the OZURDEX<sup>®</sup> group (68%) compared with Sham (21%). The
              median time of cataract being reported as an adverse event was
              approximately 15 months in the OZURDEX<sup>®</sup> group and 12
              months in the Sham group. Among these patients, 61% of OZURDEX<sup
                >®</sup
              >
              subjects versus 8% of sham-controlled subjects underwent cataract
              surgery, generally between Month 18 and Month 39 (Median Month 21
              for OZURDEX<sup>®</sup> group and 20 for Sham) of the studies.
            </p>

            <p>
              <b>Retinal Vein Occlusion and Posterior Segment Uveitis:</b>
              Adverse reactions reported by greater than 2% of patients in the
              first 6 months following injection of OZURDEX<sup>®</sup> for
              retinal vein occlusion and posterior segment uveitis include:
              intraocular pressure increased (25%), conjunctival hemorrhage
              (22%), eye pain (8%), conjunctival hyperemia (7%), ocular
              hypertension (5%), cataract (5%), vitreous detachment (2%), and
              headache (4%).
            </p>
            <p>
              Increased IOP with OZURDEX<sup>®</sup> peaked at approximately
              week 8. During the initial treatment period, 1% (3/421) of the
              patients who received OZURDEX<sup>®</sup> required surgical
              procedures for management of elevated IOP.
            </p>

            <p><b>Indications and Usage</b></p>
            <p><b>Diabetic Macular Edema</b></p>
            <p>
              OZURDEX<sup>®</sup> (dexamethasone intravitreal implant) is a
              corticosteroid indicated for the treatment of diabetic macular
              edema.
            </p>

            <p><b>Retinal Vein Occlusion</b></p>
            <p>
              OZURDEX<sup>®</sup> is a corticosteroid indicated for the
              treatment of macular edema following branch retinal vein occlusion
              (BRVO) or central retinal vein occlusion (CRVO).
            </p>

            <p><b>Posterior Segment Uveitis</b></p>
            <p>
              OZURDEX<sup>®</sup> is indicated for the treatment of
              noninfectious uveitis affecting the posterior segment of the eye.
            </p>

            <p><b>Dosage and Administration</b></p>
            <p>
              FOR OPHTHALMIC INTRAVITREAL INJECTION. The intravitreal injection
              procedure should be carried out under controlled aseptic
              conditions. Following the intravitreal injection, patients should
              be monitored for elevation in intraocular pressure and for
              endophthalmitis. Patients should be instructed to report any
              symptoms suggestive of endophthalmitis without delay
            </p>

            <p>
              <a
                href="https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/20180515-OZURDEX-USPI-v1-0USPI3348.pdf"
                target="_blank"
                v-ga="
                  $ga.commands.trackExternalLink.bind(
                    get_this,
                    'https://media.allergan.com/actavis/actavis/media/allergan-pdf-documents/product-prescribing/20180515-OZURDEX-USPI-v1-0USPI3348.pdf'
                  )
                "
              >
                <u>
                  Please click here for full Prescribing Information for
                  Ozurdex<sup>®</sup>.
                </u>
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="subpopup-container" v-else>
        <!--        <div class="back-bar">-->
        <!--          <a href="#" class="back-link" @click.prevent="back_to_list">Back</a>-->
        <!--        </div>-->
        <!--        <h1 class="text-main-color uppercase font-bold mb-8 text-center">-->
        <!--          {{ sub_popup.title }}-->
        <!--        </h1>-->
        <internal_video
          v-if="sub_popup.type == 'internal_video'"
          :item="sub_popup"
        />
        <internal_vimeo
          v-if="sub_popup.type == 'internal_vimeo'"
          :item="sub_popup"
        />
        <internal_image
          v-else-if="sub_popup.type == 'internal_image'"
          :item="sub_popup"
        />
        <internal_audio
          v-else-if="sub_popup.type == 'internal_audio'"
          :item="sub_popup"
        />
        <internal_slideshow
          v-else-if="sub_popup.type == 'internal_slideshow'"
          :item="sub_popup"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import internal_video from "./../subpopups/video";
import internal_vimeo from "./../subpopups/videoVimeo";
import internal_image from "./../subpopups/image";
import internal_audio from "./../subpopups/audioPopup";
import internal_slideshow from "./../subpopups/slideshow";

export default {
  name: "ProductLinksPopup",
  components: {
    internal_video,
    internal_vimeo,
    internal_image,
    internal_audio,
    internal_slideshow
  },
  data() {
    return {
      loading: "",
      sub_popup: null
    };
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "current_secondary_section",
      "current_secondary_sub_section",
      "sections_content"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),

    page_url() {
      //var popup_title = this.getCurrentSectionContent().title;
      //var slug = popup_title
      //  .split(" ")
      //  .join("-")
      //  .toLowerCase();

      var str =
        "/" +
        this.eventTag +
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/link-list/";
      //  +slug;

      return str;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    video_popup_class() {
      return "popup " + this.loading;
    },
    pdf_list_class() {
      let str = "pdf-list";
      str += " flex justify-evenly bg-white rounded";

      return str;
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    },
    get_this() {
      return this;
    }
  },
  methods: {
    get_item_href(item) {
      console.log("get item href");
      if ("undefined" == typeof item.type) {
        return (
          "static/content/" +
          this.selected_section +
          "/" +
          this.selected_sub_section +
          "/pdf/" +
          item.filename
        );
      } else {
        return item.filename;
      }
    },

    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    },
    try_to_close_popup(e) {
      if (this.sub_popup != null) {
        this.sub_popup = null;
      } else {
        this.close_popup(e);
      }
    },
    close_popup(e) {
      console.log("close popup");

      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_interactive_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_video_src, 10)
        );
      }

      this.$bus.$emit("send_interactive_msg", "popupClosed", 1);
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
    },
    prevent_close(e) {
      e.stopPropagation();
    },
    video_started() {
      this.loading = "";
    },

    show_internal_content(idx) {
      this.sub_popup = this.getCurrentSectionContent().list[idx];

      if (this.sub_popup.type == "internal_slideshow") {
        //internal_slideshow
        this.$ga.page(
          this.page_url +
            "content/" +
            (idx + 1) +
            "/" +
            this.sub_popup.type +
            "/" +
            this.sub_popup.title
        );
      } else {
        //internal_video
        //internal_vimeo
        //internal_image
        //internal_audio
        this.$ga.page(
          this.page_url +
            "content/" +
            (idx + 1) +
            "/" +
            this.sub_popup.type +
            "/?file=" +
            (this.sub_popup.filename || this.sub_popup.url)
        );
      }
    },
    show_external_content(idx) {
      var sub_info = this.getCurrentSectionContent().list[idx];
      this.$ga.page(
        this.page_url +
          "content/" +
          (idx + 1) +
          "/external_link/?file=" +
          sub_info.filename
      );
    },
    back_to_list() {
      this.sub_popup = null;
    }
  },
  mounted() {
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$bus.$on("request-subpopup-close", this.back_to_list);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    console.log("destroying video popup");
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 44, 107, 0.8);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  xjustify-content: center;
}
.popup_content_container {
  margin-top: auto;
  margin-bottom: auto;
  max-height: 100vh;
  max-height: calc(var(--vh, 1vh) * 100);

  width: 90vw;
  max-width: 1800px;
}

.option-bar {
  position: absolute;
  top: 3vh;
  right: 2vh;
  width: 60px;
  height: 60px;
}
.close-link {
  color: #fff;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 60px;
  height: 60px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
  cursor: pointer;
}
.popup_video_container {
  align-self: center;
  margin: auto 0;
}

.app-popup-instructions {
  background: rgba(20, 20, 20, 0.8);
  text-transform: uppercase;
}

.pdf-list {
  max-height: 33vh;
  padding: 3vh;
}
.pdf-list li {
  display: flex;
  margin: 0 8px;
  box-shadow: 0px 2px 5px 1px rgba(90, 90, 90, 0.1);
}
.pdf-list img {
  display: inline-block;
  max-height: 100%;
}
.pdf-list li a:hover {
  opacity: 0.9;
}

.back-bar {
  position: absolute;
  top: 20px;
  right: 30px;

  color: #03344a;
}

.back-bar a {
  color: #fff;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 60px;
  height: 60px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}
.popup_content_container {
  transition: height 4s ease-out;
}
.popup_video_container {
  margin: 0 auto;
}
.isi-container {
  min-height: 33vh;
  max-height: 35vh;
  overflow-y: auto;
  padding: 20px;
  font-size: 14px;
  color: #333;
}
.isi-container p {
  margin: 1em 0;
  line-height: 1.2;
}
.isi-container p:first-child {
  margin-top: 0;
}
.subpopup-container {
  text-align: center;
}

@media only screen and (max-width: 1110px),
  only screen and (max-height: 460px) {
  .close-link {
    width: 30px;
    height: 30px;
  }
}
</style>
<style></style>



// WEBPACK FOOTER //
// src/components/popups/ProductLinksPopup.vue